import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Dropdown from "../components/Dropdown";
import { useNavigate } from "react-router-dom";
import CustomButton from "../components/CustomButton";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import CustomToast from "../components/CustomToast";
import { LoadingSpinner } from "../components/Icons";
import { currentUserActions } from '../reducers/currentUser';
import {
    getCompanyOptions,
    changeStaffCompany,
    setSuccess,
    setError,
} from "../reducers/superUser";
import LogoHeader from "../components/LogoHeader";

const CompanySelection = ({view} : {view: 'company' | 'control'}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const [selected, setSelected] = useState<any>(null);
    const {
        companyOptions,
        error,
        success,
        actionName,
        loading,
    } = useSelector((state: any) => state.superUser);
    const currentUser = useSelector((state: any) => state.currentUser)

    const [company, setCompany] = useState<any>(null);
    const [companyId, setCompanyId] = useState<any>(null);

    useEffect(() => {
        dispatch(getCompanyOptions(true));
        if(currentUser?.staffInfo) {
            setCompany(currentUser.staffInfo.company);
            setCompanyId(currentUser.staffInfo.company.id);
        }
    }, []);

    useEffect(() => {
        if(companyOptions.length > 0){
            const company = companyOptions.find((option: any) => option.id === companyId);
            if(company) setSelected(company);
        }
    }, [companyOptions]);

    const handleSubmit = (e: any) => {
        e.preventDefault();
        if(!selected || !selected?.id) {
            return
        }
        const data = {
            companyId: selected.id,
        }
        dispatch(changeStaffCompany(data));
    };

    const handleChangeOption = (value: any) => {
        setSelected(value);
    }

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    useEffect(() => {
        if(error) {
            enqueueSnackbar("I love snacks.", {
                content: (key) => (
                <CustomToast
                    title={"メッセージ"}
                    message={error}
                    variant={"error"}
                    snackbarKey={key}
                    closeSnackbar={closeSnackbar}
                />
                ),
            });
            dispatch(setError(null));
        }
        else if(success) {
            dispatch(setSuccess(null));
            if(actionName == "changeStaffCompany" && selected) {
                window.location.assign("/company");
                return;
            }
        }
    }, [error, success, actionName]);

    return (
        <div className="static md:fixed md:inset-0 bg-alu-base">
            <div className="min-w-[24.75rem] static md:absolute md:top-1/2 left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2">
                <LogoHeader view={view} page="advanced"></LogoHeader>
                <div className="bg-white md:rounded-2xl md:shadow-lg md:max-w-[24.4375rem] md:m-auto md:min-h-max min-h-screen w-full py-0 md:py-6">
                <Header title="ログインする企業を選択" logoDirection="row"></Header>
                <div className="flex flex-col items-center justify-center mt-[3.125rem] md:mt-4 px-4 md:px-6">
                    <form className="bg-white w-full">
                        <div className="mb-10">
                            <p className="block mb-10 text-sm text-center tracking-[-0.28px]">
                                選択した企業にスーパーユーザーとしてログインします
                            </p>
                            <div className="w-full">
                                <Dropdown
                                    options={companyOptions}
                                    value={selected}
                                    onChange={(value: any) => handleChangeOption(value)}
                                    placeholder="選択してください"
                                    inputWidth="full"
                                    customStyle="h-auto"
                                />
                            </div>
                        </div>
                        <CustomButton
                            disabled={!selected || !selected?.id}
                            type="button"
                            size="md"
                            width="full"
                            onClick={handleSubmit}
                        >
                            <p>{loading ? "送信中..." : "ログイン"}</p>
                            {loading && (
                                <span><LoadingSpinner /></span>
                            )}
                        </CustomButton>
                    </form>
                    <div className="mt-6 gap-6 flex flex-col w-full text-center">
                        <p className="inline-flex justify-center items-center">
                            <span
                                onClick={() => navigate(-1)}
                                className="text-link px-2 py-1 hover:bg-[#fff3e5] rounded text-sm hover:cursor-pointer"
                            >戻る</span>
                        </p>
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
};

export default CompanySelection;
